import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { isBefore } from 'date-fns'

import { fetchLatestAlertData, saveAlert, deleteAlert } from '../actions/alertActions'
import AlertActionBar from './AlertActionBar'
import AlertSettings from './AlertSettings'

import '../style/alert.scss'

const Alert = (props) => {
  const [values, setValues] = useState({})
  const [endTime, setEndTime] = useState()
  const [errors, setErrors] = useState({ type: undefined, headline: undefined, endTime: undefined })
  const [isSettingsOpen, toggleSettings] = useState(false)
  const [wasManuallyClosed, setClosed] = useState(false)

  const { fetchLatestAlertData } = props
  useEffect(() => {
    fetchLatestAlertData()
    const interval = setInterval(fetchLatestAlertData, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [fetchLatestAlertData])

  useEffect(() => {
    if (!isSettingsOpen) {
      setValues({
        id: props.id,
        type: props.type,
        headline: props.headline,
        byline: props.byline
      })
      setEndTime(props.endTime ? new Date(props.endTime) : null)
    }
  }, [props, isSettingsOpen])

  const handleChange = (event) => {
    const target = event.target
    setValues({ ...values, [target.name]: target.type === 'checkbox' ? target.checked : target.value })
    setErrors({ type: undefined, headline: undefined, endTime: undefined })
  }

  const handleDateChange = (date) => {
    setErrors({ type: undefined, headline: undefined, endTime: undefined })
    isBefore(date, new Date()) ?
      setErrors({ ...errors, endTime: 'End date and time cannot be in the past' })
      : setEndTime(date)
  }

  const handleInvalid = (event) => {
    event.preventDefault()
    setErrors({ ...errors, [event.target.name]: 'Required' })
  }

  const handleCancel = () => {
    setValues({
      id: props.id,
      type: props.type,
      headline: props.headline,
      byline: props.byline,
    })
    setEndTime(props.endTime)
    setErrors({ type: undefined, headline: undefined, endTime: undefined })
    toggleSettings(!isSettingsOpen)
  }

  return (
    <div className='alert'>
      {!wasManuallyClosed &&
        <div className={'usa-alert ' + (values.type ? `usa-alert-${values.type} ` : '') + ((isSettingsOpen || values.headline) ? 'open' : 'closed')}>
          <div className='usa-alert-body'>
            {(values.headline || props.canEditSettings) && <AlertActionBar
              canEditSettings={props.canEditSettings}
              toggleSettings={toggleSettings}
              closeClicked={setClosed}
              isSettingsOpen={isSettingsOpen} />}
            {(isSettingsOpen || values.headline) 
              ? <div className='alert-message'>
                  <h3 className='usa-alert-heading'>{values.headline}</h3>
                  <p className='usa-alert-text'>{values.byline}</p>
                </div> 
              : props.canEditSettings
                ? <p className='usa-alert-text'>No alert exists</p>
                : null}
            {isSettingsOpen &&
              <AlertSettings
                id={values.id}
                type={values.type}
                headline={values.headline}
                byline={values.byline}
                endTime={endTime}
                handleDateChange={handleDateChange}
                errors={errors}
                handleChange={handleChange}
                handleInvalid={handleInvalid}
                handleCancel={handleCancel}
                saveAlert={props.saveAlert}
                deleteAlert={props.deleteAlert}
                toggleSettings={toggleSettings}
                isSettingsOpen={isSettingsOpen} />}
          </div>
        </div>}
    </div>
  )
}

const mapStateToProps = (state) => ({
  canEditSettings: state.currentUser.authorizations ? state.currentUser.authorizations.includes('Edit Alert') : false,
  ...state.alert
})

const mapDispatchToProps = { fetchLatestAlertData, saveAlert, deleteAlert }

export default connect(mapStateToProps, mapDispatchToProps)(Alert)
